import React from "react";
import { useContext } from "react";
import DataContext from "Context/DataContext";
import { Link } from "gatsby";
import CloseIcon from "assets/cancel.png";
const Cookie = () => {
  const { setShowCookie, setCookiePreference } = useContext(DataContext);

  return (
    <>
      <div
        style={{
          boxShadow:
            " 0px 0px 1px 0px rgba(96, 96, 96, 0.10), 0px 12px 24px -6px rgba(96, 96, 96, 0.15);",
        }}
        className="bg-[#2B2627] z-[2147483647]   w-screen md:px-0 px-6 ease-in-out  duration-300 fixed  right-0 left-0 bottom-0  "
      >
        <div className=" flex  items-center justify-between  max-w-7xl mx-auto gap-5   py-4 xl:px-0 lg:px-7 md:px-8   ">
          <div className="text-white font-opensans text-sm tracking-wide">
            We use cookies to ensure you get the best experience. By using our
            website you agree to our{" "}
            <Link to="/legal/cookie-policy" className="underline">
              Cookie Policy
            </Link>
            .
          </div>

          <img
            src={CloseIcon}
            className="cursor-pointer "
            style={{ objectFit: "contain" }}
            alt="close-button"
            onClick={() => {
              setShowCookie(false);
              localStorage.setItem("cookiePopup", "true");
            }}
          />
        </div>
      </div>
      {/* <div
        style={{
          boxShadow:
            " 0px 0px 1px 0px rgba(96, 96, 96, 0.10), 0px 12px 24px -6px rgba(96, 96, 96, 0.15);",
        }}
        className="bg-[#2B2627] z-[2147483647]   w-screen md:px-0 px-6 ease-in-out  duration-300 fixed  right-0 left-0 bottom-0   lg:hidden "
      >
        <div className="flex flex-col items-center justify-center  max-w-7xl mx-auto    py-4 xl:px-0 lg:px-7 md:px-8   ">
          <div className="text-white font-opensans text-sm tracking-wide">
            We use cookies to ensure you get the best experience. By using our
            website you agree to our{" "}
            <Link to="/legal/cookie-policy" className="underline">
              Cookie Policy
            </Link>
            .
          </div>
          <button
            className="mt-5 py-[6px] w-[200px] px-[18px] border border-[#ffffff] text-[#ffffff] rounded-lg"
            onClick={() => {
              setShowCookie(false);
              localStorage.setItem("cookiePopup", "true");
            }}
          >
            Ok
          </button>
        </div>
      </div> */}
    </>
  );
};

export default Cookie;
